import { Component, OnInit } from '@angular/core';
import {ApiService} from '../../../shared/services/api.service';
import {saveAs} from 'file-saver';
import {IMyDrpOptions} from 'mydaterangepicker';

@Component({
  selector: 'app-granted-discounts',
  templateUrl: './granted-discounts.component.html',
  styles: []
})
export class GrantedDiscountsComponent implements OnInit {
  public rows = [];
  public allRows = [];
  public loadingIndicator = false;

  // Filters
  public filterMarketNumber: string;
  public filterMerchantNumber: string;
  public filterMerchantCompany: string;
  public filterEmployee: string;

  dateRangePickerOptions: IMyDrpOptions;
  dateRangeModel: any;

  constructor(private apiService: ApiService) {
    this.initDaterangePicker();
    this.getGrantedDiscounts();
  }

  ngOnInit() {
  }

  initDaterangePicker() {
    this.dateRangePickerOptions = {
      dayLabels: {su: 'So', mo: 'Mon', tu: 'Di', we: 'Mi', th: 'Do', fr: 'Fr', sa: 'Sa'},
      monthLabels: { 1: 'Jan', 2: 'Feb', 3: 'Mrz', 4: 'Apr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Aug', 9: 'Sep', 10: 'Okt',
        11: 'Nov', 12: 'Dez' },
      dateFormat: 'dd.mm.yyyy',
      yearSelector: false,
      monthSelector: false,
      selectBeginDateTxt: 'Startdatum auswählen',
      selectEndDateTxt: 'Enddatum auswählen',
      showClearBtn: true,
      showApplyBtn: true,
      openSelectorOnInputClick: true,
      height: '26px',
      width: '239px'
    };

    this.dateRangeModel = {
      beginDate: {
        year: new Date().getFullYear(),
        month: new Date().getMonth() - 3,
        day: new Date().getDate()
      },
      endDate: {
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        day: new Date().getDate()
      }
    };
  }

  applyFilter() {
    let tmp = [...this.allRows];

    if (this.filterMerchantNumber) {
      tmp = tmp.filter(item => item.merchantNumber.includes(this.filterMerchantNumber));
    }
    if (this.filterMerchantCompany) {
      tmp = tmp.filter(item => item.company.includes(this.filterMerchantCompany));
    }
    if (this.filterMarketNumber) {
      tmp = tmp.filter(item => item.marketday_number.includes(this.filterMarketNumber));
    }
    if (this.dateRangeModel) {
      tmp = tmp.filter(item => {
        const date = new Date(item.evasiveDate);
        date.setMonth(date.getMonth() + 1);
        return (date <= this.getDate(this.dateRangeModel.endDate)) && (date >= this.getDate(this.dateRangeModel.beginDate));
      });
    }
    if (this.filterEmployee) {
      tmp = tmp.filter(item => {
        return (item.employeeFirstname + ' ' + item.employeeLastname).includes(this.filterEmployee)
          || item.employeeNumber.toString().includes(this.filterEmployee);
      });
    }
    this.rows = tmp;
  }

  getDate(dateObj) {
    const date = new Date();
    date.setFullYear(dateObj.year, dateObj.month, dateObj.day);
    return date;
  }

  getGrantedDiscounts() {
    this.loadingIndicator = true;
    this.apiService.get('backoffice/evaluation-discount')
      .subscribe((data) => {
        this.rows = JSON.parse(data._body);
        this.allRows = [...this.rows];
        // console.log('Evaluation Discount Data: ', this.rows);
        this.applyFilter();
        this.loadingIndicator = false;
      });
  }

  getValueBeforeDiscount(row): number {
    const percentage = row.discountPercentage * 100;
    const discount = Number.parseFloat(row.discount);
    if (percentage === 100) {
      return discount + 1;
    } else {
      return discount / percentage * 100;
    }
  }

  saveMarketStatisticsToCsv() {
    const headers = [
      'Marktnummer',
      'Marktname',
      'Marktdatum',
      'Beschickernummer',
      'Beschickerfirma',
      'Firmenzusatz',
      'Fläche in qm',
      'Standgeld vor Nachlass',
      'Standgeld in EUR',
      'Nachlassart',
      'Nachlass in %',
      'Nachlass in EUR',
      'Eingesteuert durch'];
    let body = headers.join(';') + '\r\n';

    this.rows.forEach(
      (entry) => {
        body = body.concat(entry.marketday_number, ';');
        body = body.concat(entry.keyword, ';');
        body = body.concat(this.getNormalizedDate(entry.evasiveDate), ';');
        body = body.concat(entry.merchantNumber, ';');
        body = body.concat(entry.company, ';');
        body = body.concat(entry.companyAdditional, ';');
        body = body.concat(entry.size, ';');
        body = body.concat(this.getValueBeforeDiscount(entry).toString(), ';');
        body = body.concat(parseFloat(entry.priceTotal).toFixed(2).toString(), ';');
        body = body.concat(this.getDiscountTypeLabel(entry.discountType), ';');
        body = body.concat((parseFloat(entry.discountPercentage) * 100).toString(), ';');
        body = body.concat(parseFloat(entry.discount).toFixed(2).toString(), ';');
        body = body.concat(this.getEmployeeLabel(entry), ';\r\n');
      }
    );
    const blob = new Blob([body], {type: 'text/plain;charset=utf-8'});
    saveAs(blob, 'Auswertung_Gewaehrte_Nachlaesse.csv');
  }

  getDiscountTypeLabel(value: string) {
    if (value === 'Single') { return 'Einzeln'; }
    if (value === 'Periodic') { return 'Periodisch'; }
    if (value === 'SocialOrganization') { return 'Soziale Organisation'; }
    return value;
  }

  getEmployeeLabel(entry) {
    return entry.employeeFirstname + ' ' + entry.employeeLastname + ' (' + entry.employeeNumber + ')';
  }

  getNormalizedDate(date) {
    date = new Date(date);
    return date.getDate().toString().padStart(2, '0') + '.' + date.getMonth().toString().padStart(2, '0') + '.' + date.getFullYear();
  }

}



// WEBPACK FOOTER //
// ./src/app/evaluation/components/granted-discounts/granted-discounts.component.ts